import { useEffect, useState } from "react";
import { getRequestsInGroup } from "../../services/cm.service";
import { SupplierGroup } from "./SupplierInGroupList";
import { CircleProgressIndicator } from "../CircleProgressIndicator";
import { useTranslation } from "react-i18next";

export const SuppliersTable = ({ campaign, suppliers, updateSuppliersArray, isAuthMethodOkta, token }) => {
  const campaignId = campaign ? campaign.id : "";
  const supplierNum = campaign && Array.isArray(campaign.assignments) && campaign.assignments.length > 0 ? campaign.assignments[0].supplierNumber : "";
  const [suppliersInGroup, setSuppliersInGroup] = useState([]);
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const { t } = useTranslation();

  useEffect(() => {
    if (suppliers) {
      setSelectedSuppliers([...suppliers]);
    }
  }, [suppliers]);

  const getSelectedData = (items) => {
    const data = [];
    items.forEach((i) => {
      data.push(suppliersInGroup.filter((item) => item.supplierNumber === i)[0]);
    });
    return data;
  };

  const updateSuppliersInGroup =()=>{
    if (campaign && Array.isArray(campaign.assignments) && campaign.assignments.length > 0) {
      const supplierFullName = campaign.assignments[0].supplierName;
      const responseObj = {
        id: campaign.assignments[0].id,
        status: campaign.assignments[0].status,
        supplierNumber: campaign.assignments[0].supplierNumber,
        groupNumber: null,
        supplierName: supplierFullName
      };
      setSuppliersInGroup([responseObj]);
    }
  }
  useEffect(() => {
    if (campaignId && supplierNum) {
      if(campaign.isNonDeere || !isAuthMethodOkta){
        updateSuppliersInGroup();
      }else{
        getRequestsInGroup(supplierNum, campaignId, token).then((response) => {
          if (Array.isArray(response) && response.length > 0) {
            setSuppliersInGroup(response);
          } else {
            updateSuppliersInGroup();
          }
        });
      }
    }
  }, [token, campaignId]);

  const onCheck = (event) => {
    let aux = [...selectedSuppliers];
    if (event.target.checked) {
      aux.push(event.target.defaultValue);
      setSelectedSuppliers([...aux]);
      updateSuppliersArray(getSelectedData([...aux]));
    } else {
      setSelectedSuppliers(aux.filter((it) => it !== event.target.defaultValue));
      updateSuppliersArray(getSelectedData(aux.filter((it) => it !== event.target.defaultValue)));
    }
  };
  const onCheckAll = (event) => {
    let aux = [];
    if (event.target.checked) {
      for (let it of suppliersInGroup) {
        if (!it.groupNumber) {
          aux.push(it.supplierNumber);
        }
      }
    }
    setSelectedSuppliers([...aux]);
    updateSuppliersArray(getSelectedData([...aux]));
  };
  return (
    <>
      {suppliersInGroup.length > 0 ? (
        <SupplierGroup
          list={suppliersInGroup}
          onCheck={onCheck}
          onCheckAll={onCheckAll}
          selectedSuppliers={selectedSuppliers && selectedSuppliers.length > 0 ? selectedSuppliers : suppliers}
          campaign={campaign}
          sx={{ tableRowStyle: { fontSize: "12px", paddingTop: "0", paddingBottom: "0" } }}
        />
      ) : (
        <CircleProgressIndicator title={t("lbl_supplier_group_loading")} />
      )}
    </>
  );
};
